import CityPageTemplate from "../city-template/CityPageTemplate";
import { wilmingtonConfig } from "./data";

export default function WilmingtonPage() {
  return <CityPageTemplate config={wilmingtonConfig} />;
}